// extracted by mini-css-extract-plugin
export default {"homePage":"homePage___Ee769","mainContent":"mainContent___xc1tK","sidebar":"sidebar____b9JG"};